module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor05-17ad7b16aa1c727b203f70d48228e238.pdf";